var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailPlane3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 68,
    viewBox: "0 0 59 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1184 36.6938L50.6473 24.5335L37.3241 44.3418L34.1184 36.6938Z",
    fill: "#0CF2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.274 22.1966L50.6474 24.5338L34.1185 36.6941L13.688 62.8926L27.274 22.1966Z",
    fill: "#B9DAF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6878 62.8923L34.1183 36.6938L37.324 44.3417L43.6003 59.3155L13.6878 62.8923Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3495 6.35705L27.274 22.1966L13.688 62.8926L20.3495 6.35705Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.688 62.8926L34.1185 36.6941L50.6474 24.5338L27.274 22.1966L20.3495 6.35705L13.688 62.8926Z",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2738 22.1963L13.6878 62.8923L43.6003 59.3155L37.324 44.3417L34.1183 36.6938",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.647 24.5335L37.3237 44.3418",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPlane3);
export default __webpack_public_path__ + "static/media/email-plane-3.aa2c8a879df2cf1067024a9d88ed402f.svg";
export { ForwardRef as ReactComponent };